import { ObservableProp, useClassStore } from '@Utils/useClassStore';
import { injectable } from 'inversify';

import container from '~ioc/ioc';

@injectable()
class SelectPresenter {
  selectOpened = new ObservableProp(false);
}

export const useSelectPresenter = () =>
  useClassStore<SelectPresenter>(container.get(SelectPresenter));
